import React from "react";
import { Heading, BodyTextAlt, BodyText } from "~/components/.base/headings";
import FoodTruckIcon from "~/images/icons/food_truck.svg";
import ForkKnifeIcon from "~/images/icons/fork_knife.svg";
import styled from "styled-components";
import { Link } from "gatsby";

const FoodItem = styled.div`
	display: flex;
	padding: 0.5rem 0;
	svg {
		width: 20px;
		min-width: 20px;
		height: 20px;
		margin-right: 1rem;
		margin-bottom: 1rem;
		g {
			fill: #d4212c;
		}
	}
	.title {
		transition: 0.2s color linear;
	}
	@media screen and (min-width: 768px) {
		&:hover .title {
			color: #d4212c;
		}
	}
`;

const Location = ({ state, items }) => {
	return (
		<div id={state.title} style={{ marginBottom: "1rem" }}>
			<Heading>{state}</Heading>
			{items && items.length
				? items.map((item, i) => {
						return (
							<Link
								key={i}
								to={`/locations/details/${item.handle}`}
							>
								<FoodItem>
									{item.isATruck ? (
										<FoodTruckIcon />
									) : (
										<ForkKnifeIcon />
									)}
									<div>
										<BodyTextAlt
											className="title"
											color="#2d3333"
											md="0 0 .25rem"
										>
											{item.title}
										</BodyTextAlt>
										<BodyText color="#8a9899" md="0">
											{item.isATruck
												? "Truck"
												: "Restaurant"}{" "}
										</BodyText>
									</div>
								</FoodItem>
							</Link>
						);
				  })
				: null}
		</div>
	);
};

export default Location;
